import { ca } from '@cian/analytics';

export function trackInfrastructureShow() {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'CardJK',
    label: 'infrastructure',
    name: 'oldevent',
    useLastProducts: true,
  });
}
